import { SWRConfiguration } from 'swr'
import {
  CampaignAssets,
  getCampaignAssets,
} from '@/services/api/campaignAssets'
import useApi from '../useApiV2'

const useCampaignAssets = (slug: string, config?: SWRConfiguration) => {
  const { data, ...rest } = useApi<CampaignAssets>({
    key: `campaign-assets/${slug}`,
    request: () => getCampaignAssets(slug),
    config,
  })

  return { campaignAssets: data, ...rest }
}

export default useCampaignAssets
